const olListCustomNumeric = content => {
  // Get all HTML tags <ol>
  const htmlOlTags = content.querySelectorAll("ol");
  for (let i = 0; i <= htmlOlTags.length - 1; i++) {
    // Check or ol list numbered
    if (!htmlOlTags[i].getAttribute("style")) {
      htmlOlTags[i].classList.add("custom-list");

      // Get numbered lists li tags
      const numberedLiTags = htmlOlTags[i].getElementsByTagName("li");
      for (let i = 0; i <= numberedLiTags.length - 1; i++) {
        // Remove old span when list or page editing
        removeOldSpan(numberedLiTags[i], "custom-numeric");

        // Create new numbers list
        const node = document.createElement("span");
        node.classList.add("custom-numeric");
        const countNode = document.createTextNode(`${i + 1}. `);
        node.appendChild(countNode);

        // Check if li has children element
        if (numberedLiTags[i].children.length > 0) {
          // Check if li children has children element
          if (
            numberedLiTags[i].firstElementChild.children.length > 0 &&
            numberedLiTags[i].firstElementChild.firstElementChild.tagName !== "BR"
          ) {
            // Add new number list to li children children element
            numberedLiTags[i].firstElementChild.firstElementChild.prepend(node);
          } else {
            // Add new number list to li children element
            numberedLiTags[i].firstElementChild.prepend(node);
          }
        } else {
          // Add new number list to li without children
          numberedLiTags[i].prepend(node);
        }
      }
    }
  }
};

const removeOldSpan = (listArray, spanClass) => {
  const oldSpans = listArray.querySelectorAll("." + spanClass);
  for (let i = 0; i <= oldSpans.length - 1; i++) {
    oldSpans[i].remove();
  }

  return oldSpans;
};

export { olListCustomNumeric };
